/**
 * Home composer stimuli hand-off. The home `+` hosts each image/video on ingest, then
 * the submit mints a thread or a room and navigates. The tiles ride HERE, in memory and
 * keyed by the destination token, rather than in router state or sessionStorage: a
 * video's bytes (and a few compressed images) can exceed what history state and the
 * ~5MB sessionStorage quota hold, and a reload must never resend them.
 *
 * `take` is one-shot: the destination page reads the tiles once and the entry is gone.
 */

import { ChatImage } from '@/lib/api'

const pendingByToken = new Map<string, Array<ChatImage>>()

export function stashHomeStimuli(token: string, stimuli: Array<ChatImage>): void {
  if (!token || stimuli.length === 0) {
    return
  }
  pendingByToken.set(token, stimuli)
}

export function takeHomeStimuli(token: string | null | undefined): Array<ChatImage> {
  if (!token) {
    return []
  }
  const stimuli = pendingByToken.get(token) ?? []
  pendingByToken.delete(token)
  return stimuli
}

/** True without consuming, so a page can wait for readiness before it takes them. */
export function hasHomeStimuli(token: string | null | undefined): boolean {
  return Boolean(token) && pendingByToken.has(token as string)
}
